import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { FormattedMessage } from "react-intl";
import Input from "@amzn/meridian/input";
import Alert from "@amzn/meridian/alert";
import { logOperationalMetric } from "../../../overview/utils/utils";
import Box from "@amzn/meridian/box";
import { useDeviceLayout } from "../../../common/context/DeviceLayoutContext";
import { getAliasByEmail } from "../../../util/Util";
import { DolphinVerificationProcessName } from "../../../util/Constants";

function ManualLoginOption({
  alias,
  setAlias,
  showQRCode,
  onGenerateQRCode,
  aliasError,
  setAliasError,
}) {
  const [inputFocusTime, setInputFocusTime] = useState(null);

  const { isMobile } = useDeviceLayout();
  const widths = isMobile ? "90%" : "45%";
  const onCancelClick = () => {
    setAlias("");
    setAliasError(false);
  };
  const onNextClick = () => {
    alias = alias.toLowerCase();
    const alias_val = getAliasByEmail(alias);
    setAlias(alias_val);
    logOperationalMetric(
      Date.now() - inputFocusTime,
      DolphinVerificationProcessName,
      "Manual_Input",
      true,
    );
    onGenerateQRCode(alias_val);
  };

  return (
    <Box
      width="100%"
      type="outline"
      spacing="1000"
      backgroundColor="#DFE3E8"
      spacingInset="400"
    >
      <Row>
        <Alert size="small" type="informational">
          <strong>
            <FormattedMessage
              id="verificationOptions.text.info"
              defaultMessage="Input associate's info"
            />
          </strong>
        </Alert>
      </Row>
      <Row spacingInset={"100 none none 450"}>
        <p
          style={{
            fontSize: "14px",
          }}
        >
          <FormattedMessage
            id="verificationOptions.text.subHeading"
            defaultMessage="Verification will be valid until the end of your shift or until associate logout."
          />
        </p>
      </Row>
      <Row spacingInset={"400 none none 450"}>
        <FormattedMessage
          id="verificationOptions.text.inputAlias"
          defaultMessage="Associate's Login ID"
        />
      </Row>
      <Row spacingInset={"100 none none 450"}>
        <Input
          type="text"
          value={alias}
          onChange={setAlias}
          autoFill={true}
          onFocus={() => setInputFocusTime(Date.now())}
          width={widths}
        />
      </Row>
      <div>
        {aliasError && !showQRCode && (
          <Row spacingInset={"200 none none 450"}>
            <Alert size="small" type="error">
              <FormattedMessage
                id="verificationOptions.text.error"
                defaultMessage="Associate not found. Confirm credentials and enter again."
              />
            </Alert>
          </Row>
        )}
      </div>
      <Row spacingInset={"400 none none 450"} spacing={"300"}>
        <Button
          size="medium"
          disabled={!alias}
          type="tertiary"
          onClick={onCancelClick}
        >
          <FormattedMessage
            id="verificationOptions.button.cancel"
            defaultMessage="Cancel"
          />
        </Button>
        <Button size="medium" disabled={!alias} onClick={onNextClick}>
          <FormattedMessage
            id="verificationOptions.button.verify"
            defaultMessage="Next"
          />
        </Button>
      </Row>
    </Box>
  );
}

export default ManualLoginOption;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/verificationWindow/verificationOptions/ManualLogin.js